module.exports = __webpack_public_path__ + "static/media/3740.ed289104.jpg";